import React, { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowBack, Email } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { confirm_password_api } from "../../DAL/auth/login";
import InfoIcon from "@mui/icons-material/Info";
import { getPasswordStrength } from "../../components/menu/PasswirdStrength";

export default function ConfirmPassword() {
  const location = useLocation();
  const email = location?.state?.email;
  const navigate = useNavigate();
  const [confirmStates, setConfirmStates] = useState({
    enter_new_password: "",
    confirm_new_password: "",
  });

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // Password strength state
  // const [passwordStrength, setPasswordStrength] = useState("");
  // Password requirements box state
  const [showRequirements, setShowRequirements] = useState(true);

  // Remove checkPasswordStrength
  // const checkPasswordStrength = (password) => {
  //   let strength = 0;
  //   if (password.length >= 8) strength++;
  //   if (/[A-Z]/.test(password)) strength++;
  //   if (/[a-z]/.test(password)) strength++;
  //   if (/[0-9]/.test(password)) strength++;
  //   if (/[^A-Za-z0-9]/.test(password)) strength++;
  //   if (strength <= 2) return "Weak";
  //   if (strength === 3 || strength === 4) return "Medium";
  //   if (strength === 5) return "Strong";
  //   return "";
  // };
  const handleChange = (e) => {
    setConfirmStates({ ...confirmStates, [e.target.name]: e.target.value });
    // No need to set passwordStrength, will use getPasswordStrength directly
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const password = confirmStates.enter_new_password;
    const confirmPassword = confirmStates.confirm_new_password;

    // Validation checks
    if (password.length < 8) {
      enqueueSnackbar("Password must be at least 8 characters.", {
        variant: "error",
      });
      return;
    }
    if (!/[A-Z]/.test(password)) {
      enqueueSnackbar("Password must contain at least one uppercase letter.", {
        variant: "error",
      });
      return;
    }
    if (!/[a-z]/.test(password)) {
      enqueueSnackbar("Password must contain at least one lowercase letter.", {
        variant: "error",
      });
      return;
    }

    if (!/[!@#$%^&*]/.test(password)) {
      enqueueSnackbar(
        "Password must contain at least one special character (!@#$%^&*).",
        { variant: "error" }
      );
      return;
    }
    if (!/[0-9]/.test(password)) {
      enqueueSnackbar("Password must contain at least one number (0-9).", {
        variant: "error",
      });
      return;
    }
    if (password !== confirmPassword) {
      enqueueSnackbar("New password and confirm password do not match.", {
        variant: "error",
      });
      return;
    }

    const confirm_post_data = {
      email: email,
      password: password,
      confirm_password: confirmPassword,
    };
    setLoading(true);
    const response = await confirm_password_api(confirm_post_data);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      navigate("/login");
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };

  return (
    <div className="container login_page">
      <div className="mt-4">
        {" "}
        <div
          style={{
            marginTop: "90px",
            marginRight: "40px !important",
            paddingLeft: "0px",
          }}
        >
          <Link
            style={{
              color: "#fff",
              textDecoration: "none",
              marginRight: "45px",
              fontWeight: "normal",
            }}
            to={"/login"}
          >
            <ArrowBack sx={{ marginRight: "5px" }} className="arrow-mui" />
            Back To Login? Login
          </Link>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-4 login-box mt-4">
          <h2 className="login-title">Create a New Password</h2>

          <form onSubmit={handleSubmit}>
            <div
              className="input-group-password"
              style={{ position: "relative" }}
            >
              <label htmlFor="">New Password*</label>
              <input
                required
                style={{ borderRadius: "5px" }}
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter new password*"
                className="input-field"
                name="enter_new_password"
                onChange={handleChange}
                value={confirmStates.enter_new_password}
              />
              <span
                className="eye-icon position-absolute"
                onClick={() => setPasswordVisible(!passwordVisible)}
                style={{ right: "18px", top: "30px", cursor: "pointer" }}
              >
                {passwordVisible ? (
                  <VisibilityOutlinedIcon className="eye-icon" />
                ) : (
                  <VisibilityOffOutlinedIcon className="eye-icon" />
                )}
              </span>
              {/* Password strength progress bar and label */}
              {confirmStates.enter_new_password &&
                (() => {
                  const { level, color, percentage } = getPasswordStrength(
                    confirmStates.enter_new_password
                  );
                  return (
                    <div style={{ width: "100%", marginTop: 8 }}>
                      <div
                        style={{
                          height: 8,
                          borderRadius: 4,
                          background: "#eee",
                          width: "100%",
                          overflow: "hidden",
                          marginBottom: 6,
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${percentage}%`,
                            background: color,
                            transition: "width 0.3s, background 0.3s",
                          }}
                        ></div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: color,
                            minWidth: 120,
                            maxWidth: 120,
                            textTransform: "capitalize",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {level}
                          <span
                            style={{
                              marginLeft: 6,
                              cursor: "pointer",
                              verticalAlign: "middle",
                              color: "#1976d2",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                            onClick={() => setShowRequirements((prev) => !prev)}
                            title="Password requirements"
                          >
                            <InfoIcon
                              style={{ fontSize: 16, color: "#1976d2" }}
                            />
                          </span>
                        </span>
                      </div>
                      {/* Password requirements shown only when info icon is clicked */}
                      {showRequirements && (
                        <div
                          style={{
                            background: "#f8f9fa",
                            borderRadius: 6,
                            padding: "12px 16px",
                            marginBottom: 18,
                            marginTop: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                          }}
                        >
                          <strong style={{ fontSize: 14 }}>
                            Password Requirements
                          </strong>
                          <ul
                            style={{
                              fontSize: 13,
                              marginBottom: 0,
                              marginTop: 6,
                            }}
                          >
                            <li>At least 8 characters</li>
                            <li>One uppercase letter (A-Z)</li>
                            <li>One lowercase letter (a-z)</li>
                            <li>One number (0-9)</li>
                            <li>One special 5(!@#$%^&*)</li>
                          </ul>
                        </div>
                      )}
                    </div>
                  );
                })()}
            </div>
            <div className=" position-relative input-password mt-0">
              <label htmlFor="">Confirm New Password*</label>

              <input
                required
                style={{ borderRadius: "5px" }}
                type={confirmPasswordVisible ? "text" : "password"}
                placeholder="Confirm new password*"
                className="input-field"
                name="confirm_new_password"
                onChange={handleChange}
              />
              <span
                className="eye-icon position-absolute"
                onClick={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
                style={{ right: "18px", top: "30px", cursor: "pointer" }}
              >
                {confirmPasswordVisible ? (
                  <VisibilityOutlinedIcon className="eye-icon" />
                ) : (
                  <VisibilityOffOutlinedIcon className="eye-icon" />
                )}
              </span>
            </div>
            <button type="submit" className="large-button-contained">
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
